import { z } from "zod";
import { IdType } from "./base.validator";
import { createdUser } from "./users.validator";
import { fileMeta } from "./files.validator";
import { paginateSchema } from "./pagination.validator";

export enum ResourceType {
	Announcement = "Announcement",
	Resource = "Resource",
}

export const createdResource = z.object({
	id: IdType,
	title: z.string(),
	content: z.string(),
	resourceType: z.nativeEnum(ResourceType),
	accountId: IdType,
	uploader: createdUser.pick({ id: true, firstName: true, lastName: true }),
	attachments: fileMeta.array(),
	publishDate: z.string().datetime().nullable(),
	createdAt: z.string().datetime(),
});

export type CreatedResourceDto = z.infer<typeof createdResource>;

export const paginatedCreateResource = paginateSchema(createdResource);

export type PaginatedCreateResourceDto = z.infer<
	typeof paginatedCreateResource
>;

export const createResourceInput = createdResource
	.extend({ attachmentIds: IdType.array(), draft: z.boolean().optional() })
	.omit({
		id: true,
		uploader: true,
		accountId: true,
		attachments: true,
		createdAt: true,
		publishDate: true,
	});

export type CreateResourceInputDto = z.infer<typeof createResourceInput>;

export const updateResourceInput = createResourceInput
	.omit({ draft: true })
	.partial();

export const publishResourceInput = z.object({
	publish: z.boolean(),
});

export const findResourceFilter = createdResource
	.pick({ id: true, accountId: true, resourceType: true })
	.extend({
		text: z.string().optional(),
		isPublished: z.enum(["true", "false"]),
		startDate: z.string().datetime(),
		endDate: z.string().datetime(),
		limit: z.number().optional(),
		page: z.number().optional(),
	})
	.partial();

export type FindResouceFilter = z.infer<typeof findResourceFilter>;

export const deleteResource = z.object({
	resourceId: IdType,
});
